define('bindingHandlers/clickCopy',[
    'lib/lodash4',
    'jquery',
    'lib/knockout',
    'lib/clipboard/ZeroClipboard',
    'services/contextService'
], function(
    _,
    $,
    ko,
    ZeroClipboard,
    contextService
    ){
    "use strict";

    var SWF_PATH          = '//cdnjs.cloudflare.com/ajax/libs/zeroclipboard/2.0.0/ZeroClipboard.swf',
        CLIPBOARD_CLIENT  = 'clipboard-client',
        READY_CLASS       = 'is-ready',
        DISABLED_CLASS    = 'is-disabled',

        PROP_MIME_TYPE    = 'mimeType',
        PROP_AFTER_COPY   = 'afterCopy',
        PROP_DISABLED     = 'disabled',
        PROP_ON_ERROR     = 'onError',
        PROP_IS_SUPPORTED = 'isSupported',

        EVT_ERROR         = 'error',
        EVT_READY         = 'ready',
        EVT_COPY          = 'copy',
        EVT_AFTER_COPY    = 'aftercopy',

        DEFAULT_MIME_TYPE = 'text/plain',

        EVENT_NAMESPACE   = '.clickCopy',
        EVENT_CLICK       = 'click',
        DESKTOP_EVENT     = 'copyToClipboard',

        DEFAULT_CONFIG = {
            swfPath: SWF_PATH,
            trustedDomains: ["*"],
            allowScriptAccess: "always",
            forceHandCursor: true
        },

        getElementValue = function ($element) {
            var value = $element.val();
            if (_.isUndefined(value) || _.isNull(value) || _.isEmpty(value)){
                value = $element.text().trim();
            }
            return value;
        },

        createClient = function($element, options) {
            ZeroClipboard.config(_.assign(_.clone( DEFAULT_CONFIG ), options));
            return new ZeroClipboard($element);
        };

    /**
     * Clipboard copy binding,  This adds a click event listener to an element which writes to the clipboard.
     * @example:
     * Minimal example - copies whatever the inner text or value from an element
     *
     * <input data-bind="clickCopy" value="my values for this input"> or
     * <input data-bind="clickCopy" data-bind="value:myBoundValue"> or
     * <a href="#" data-bind="clickCopy">The inner text for this element</a>
     *
     * @example:
     * Bound Observable example - copies the value of calling a bound observable or value function
     *
     * <input data-bind="clickCopy:myValueFunction"> or
     * <a href="#" data-bind="clickCopy:myObservableValue">Click Here to Copy</a>
     *
     * Note: an observable bound to the isSupported property will be undefined until the determination is
     * made that copy to clipboard is supported.  If it is supported the value will be set to true, otherwise false
     *
     * @example
     * Extended Configuration - If you would like to set callbacks for when the user copies
     * you can set them via a configuration object.  All other ZeroClipboard configurations can be
     * set this way as well.  The default configuration should be sufficient for most situations.
     * <input data-bind="clickCopy:{
     *                     afterCopy   : functionThatShowsMessageToUserThatItemWasCopied,
     *                     onError     : functionThatHandlesErrorConditions
     *                     value       : observableOrValueFunction,
     *                     swfPath     : 'new/path/to/swf/file',
     *                     isSupported : functionThatIndicatesWhetherCopyToClipboardIsSupported
     *                   }">
     * @Styling:
     * Zero Clipboard adds classes to its target elements. Example usage:
     *
     *   .clip_button {
     *       width: 150px;
     *       text-align: center;
     *       border: 1px solid black;
     *       background-color: #ccc;
     *       margin: 10px;
     *       padding: 10px;
     *     }
     *     .clip_button.zeroclipboard-is-hover { background-color: #eee; }
     *     .clip_button.zeroclipboard-is-active { background-color: #aaa; }
     *
     * @type {{init: init, update: update}}
     */

    ko.bindingHandlers.clickCopy = {
      init: function(element, valueAccessor){
          var $element = $(element),
              value    = ko.unwrap(valueAccessor()),
              client   = null,

              configOptions = _.isPlainObject( value ) ? value : { value : valueAccessor() },

              copyMimeType = _.has(configOptions, PROP_MIME_TYPE) ?
                  configOptions[PROP_MIME_TYPE] :
                  DEFAULT_MIME_TYPE,

              afterCopy = _.isFunction(configOptions[PROP_AFTER_COPY]) ?
                  configOptions[PROP_AFTER_COPY] :
                  _.noop,

              onError = _.isFunction(configOptions[PROP_ON_ERROR]) ?
                  configOptions[PROP_ON_ERROR] :
                  _.noop,

              isSupported = _.isFunction(configOptions[PROP_IS_SUPPORTED]) ?
                  configOptions[PROP_IS_SUPPORTED] :
                  _.noop,

              getDataForClipboard = function ($element) {
                  if (_.has( configOptions, 'value' ) && _.isFunction(configOptions.value)){
                      return configOptions.value();
                  }
                  return getElementValue($element);
              },

              setDisabled = function(){
                  $element
                      .prop(PROP_DISABLED, true)
                      .addClass(DISABLED_CLASS);
              },
              setEnabled = function(){
                  $element
                      .prop(PROP_DISABLED, false)
                      .removeClass(DISABLED_CLASS)
                      .addClass(READY_CLASS);
              };


          if (contextService.isDeskTop()){
              setDisabled();

              if (window._HostedContextFunctions && _.isFunction( window._HostedContextFunctions.sendEventToDesktop)){
                  isSupported(true);
                  setEnabled();
                  $element.on( EVENT_CLICK + EVENT_NAMESPACE, function(){
                    try{
                        window._HostedContextFunctions.sendEventToDesktop(
                            DESKTOP_EVENT,
                            {text: getDataForClipboard($element)}
                        );
                        _.defer(afterCopy);
                    } catch(e){
                        onError.apply(this, [e]);
                    }
                  });
              } else {
                  isSupported(false);
              }
          } else {
              setDisabled();

              if (!ZeroClipboard.isFlashUnusable()) {
                  client = createClient($element, configOptions);

                  if (client){
                      client.on(EVT_ERROR, function () {
                          onError.apply(this, _.toArray(arguments));
                      });

                      client.on(EVT_READY, function () {
                          isSupported(true);
                          setEnabled();
                      });

                      client.on(EVT_COPY, function (event) {
                          var clipboard = event.clipboardData;
                          clipboard.setData(copyMimeType, getDataForClipboard($element));
                      });

                      client.on(EVT_AFTER_COPY, function () {
                          afterCopy();
                      });

                      ko.utils.domData.set(element, CLIPBOARD_CLIENT, client);
                  }
              } else {
                  isSupported(false);
              }
          }

          ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
              var clipboardClient = ko.utils.domData.get(element, CLIPBOARD_CLIENT);
              if (clipboardClient){
                  clipboardClient.off();
                  clipboardClient.destroy();
              }

              $(element)
                  .removeClass(DISABLED_CLASS)
                  .removeClass(READY_CLASS)
                  .prop(PROP_DISABLED, false)
                  .off(EVENT_NAMESPACE);
          });


        }
    };
});

